<template>

  <div id="challanDocument" style="background:#FFFFFF;">
            <table  width="100%" style="font-size:12px; background-color: #FFFFFF; margin-top:5px;" >
                <thead >
                    <tr>
                        <td colspan="6" style="text-align: center; font-size: 18px; padding: 1% 0;">
                            <label ><strong>{{ challan?.reLocation=='1' ? 'RE-LOCATION CHALLAN' : 'DELIVERY CHALLAN' }}</strong></label>
                        </td>
                    </tr>
                    <tr>
                        <td rowspan="3" colspan="2" style="padding-left:1%; padding-bottom:3%;">
                            <label style="font-size:16px;"><strong>Arengh Medical Supplier</strong></label><br>
                            HAWAKHANA, TURA, South West Garo Hills, Meghalaya, 794001<br>
                            DL No.: WGH/WL-1321, 1322 <br>
                            GSTIN/UIN: 17ABEFA6546N1Z1 <br>
                            State Name: Meghalaya, Code 17
                        </td>
                        <td colspan="2" class="header-cell-padding">Delivery Note No. <br> <strong> {{challan?.dcNo}}</strong></td>
                        <td colspan="2" class="header-cell-padding">Dated <br> <strong>{{challan?.dcDate}}</strong></td>
                    </tr>
                    <tr>
                        <td colspan="2" class="header-cell-padding">Ref No. <br></td>
                        <td colspan="2" class="header-cell-padding" style="padding-bottom:1%" >Dated<br> </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="header-cell-padding wrap-long-po">Buyer's Order No. <br><strong>{{challan?.deptPo}}</strong></td>
                        <td colspan="2" class="header-cell-padding">Dated <strong><br> {{challan?.deptPoDate}}</strong> </td>
                    </tr>
                    <tr>
                        <td style="padding-left:1%; padding-bottom:3%;" colspan="2"> Buyer (Bill to) <br> <strong> The {{challan?.dept.head}}</strong>
                            <br>
                            {{challan?.dept.name}} <br>
                            State Name: {{challan?.dept.state}}, Code: {{challan?.dept.code}}
                        </td>
                        <td colspan="4" class="header-cell-padding" style="padding-bottom:3%">
                            Place of Delivery <br>
                            <strong>{{challan?.location.name}}</strong>
                        </td>
                    </tr>
                    <tr>
                        <th class="sl-no-width" >Sl No.</th>
                        <th colspan="3" class="item-descrption-width" >Description of Goods</th>  
                        <th class="hsn-width">HSN/SAC</th>
                        <th class="qty-width">Quantity</th>
                    </tr>                      
                    </thead>
        
                    <tbody >                    
                        <tr v-for="(item, index) in items" :key="index" style="padding-top:0%;">
                            <td align="center" class="border-hidden" style="padding-bottom: 1%;">
                                    {{item.slNo}}                                                  
                            </td>
                            <td class="border-hidden" style="padding-left:2%; padding-bottom:1%; padding-top: 1%;"  colspan="3" > 
                                <strong> {{item.name}}</strong>
                                <br>                            
                                    <div  v-if="item.category!='Equipment' || item.category!='EQUIPMENT'">
                                <label > 
                                    <em>
                                        <div v-if="item.batch_no">
                                            &nbsp;&nbsp; Batch : <strong>{{item.batch_no}}</strong><br>
                                        </div>
                                        <div v-if="item.mfgDate">
                                            &nbsp;&nbsp; Mfg Date: <strong>{{item.mfgDate}}</strong><br>
                                        </div>
                                        <div v-if="item.expDate">
                                            &nbsp;&nbsp; Exp Date: <strong>{{item.expDate}}</strong><br>
                                        </div>
                                    </em>
                                </label>
                                </div>
                                <div v-if="item.category=='Equipment' || item.category=='EQUIPMENT'">
                                <label > <em>
                                &nbsp;&nbsp; Model : <strong>{{item.modelNo}}</strong><br>
                                &nbsp;&nbsp; Serial: <strong>{{item.partNo}}</strong><br> 
                                </em></label>
                                </div>
                            </td>

                            <td class="border-hidden" align="center"  >
                                    {{item.hsn}}
                            </td>
                            <td class="border-hidden" align="center"  >
                                    <strong> {{formatCurrency(item.qty)}} {{item.packing}}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td ><div id="additional-padding" ></div></td>
                            <td colspan="3" ><div id="additional-padding"></div></td>
                            <td ><div id="additional-padding"></div></td>
                            <td ><div id="additional-padding"></div></td>
                        
                        </tr>
                    </tbody>
                            
                    <tfoot>
                        <tr>
                            <td colspan="4" align="right" style="padding-right:1%;">Total</td>
                            <td ></td>
                            <td style="padding-left:1%; padding-right:1%;" ><strong> {{formatCurrency(totalItemQty)}}</strong></td>
                            <!-- <td style="padding-left:2%; " ></td> -->
                        </tr>
                        <tr>
                            <td colspan="6" align="right" style="padding-bottom:6%; padding-right:1%">
                                    E. & O.E
                            </td>
                        </tr>
                        <tr >
                            <td colspan="3" style="padding-bottom:12%; padding-left:1%; width:350px;">Recd in Good Condition</td>
                            <td colspan="3" align="right" style="padding-right:1%; padding-top:1%; width:250px;"><strong> For Arengh Medical Supplier </strong><br> <br><br><br><br>
                                Authorised Signatory
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6" class="footer-caption">This is a computer generated document</td>
                        </tr>
                    </tfoot>                    
                </table>
            </div>

</template>

<script>
import { getReLocationChallan } from '@/services/apiService';

export default {
    name:'DeliveryChallanDoc',

    data(){
        return{
            isVisible:false,
            dialogHeader:'Print Challan',
            loadingApi:false,
            challan:null,
            items:[],
            totalItemQty:0,
            slNo:0,
        }
    },
    mounted(){        
        this.fetchChallanData();
    },
    methods:{
        async fetchChallanData(){            
            const query = '?cancel[eq]=0&id[eq]='+this.$route.params.id;    
            getReLocationChallan(query).then((response) => {
                this.challan = response.data[0];
                const mergedItems = this.challan.dcItems.reduce((i, j) => {
                    const obj = i.find((obj) => obj.poItemId === j.poItemId);
                    if(!obj){
                        i.push(j); 
                    }
                    else{
                        j.name = null;
                        i.push(j); 
                    }
                    return i;
                }, []);
    
                mergedItems.sort((a, b) => a.poItemId.localeCompare(b.poItemId));
                mergedItems.map(this.assignSlNo)            
                this.items = []
                this.items = [...mergedItems]
    
                this.items.forEach(e => {
                    this.totalItemQty += e.qty;
                });
            }).then(()=>{
                setTimeout(() => {
                    window.print();
                }, 1000);
            }).catch((error) => {
                this.showErrorToast(error.response.data);
            });
        },
        assignSlNo(item){
            if(item.name){
                item.slNo = ++this.slNo;
            }
            return item;
        },
        formatCurrency(value) {
            return value.toLocaleString('en-IN');
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 5000 });
        },
    }
}
</script>

<style scoped>
  
  table, th, td {
    border: 0.5px solid black;
    border-collapse: collapse;
    border-color: rgb(170, 170, 170);
  }

  .header-cell-padding{
      padding-left: 1%;
      padding-right: 1%;
  }

  .sl-no-width{
      width: 28px;
  }

  .item-descrption-width {
      width:559px;
  }

  .hsn-width {
      width:65px;
  }

  .qty-width {
      width:62px;
  }

  .border-hidden {
    border-bottom-style: hidden;
  }

  #additional-padding {
    grid-template-columns: 100%;
    z-index: 1;
    padding-bottom: 10%;
    /* max-height: 50vh;
    min-height: 50vh; */
    height: 40vh;
  }

  .footer-caption {
      padding-top: 1%;
      border: none;
      border-bottom-style: hidden;
      border-right-style: hidden;
      border-left-style: hidden;
      /* border-style: hidden; */
      text-align: center;
  }

</style>